import i18next from 'i18next';
import { Logger } from 'ia-react-core';
import React, { FC } from 'react';
import { setCookies } from './setCookies';

export interface LanguageChangedProps {
  logger?: Logger;
}

const LanguageChanged: FC<LanguageChangedProps> = ({ logger }) => {
  // eslint-disable-next-line no-void
  const setCookiesCb = React.useCallback(() => void setCookies(logger), [logger]);
  React.useEffect(() => {
    i18next.on('languageChanged', setCookiesCb);
    return () => {
      i18next.off('languageChanged', setCookiesCb);
    };
  });
  return null;
};

LanguageChanged.displayName = 'LanguageChanged';

export default LanguageChanged;
